<span matTooltip="{{text}}">{{ text | limitTo:limit }}</span>